import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthenticationStore } from '../../states/auth/auth.store';

@Component({
  selector: 'app-no-access',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './no-access.component.html',
  styleUrl: './no-access.component.scss',
})
export class NoAccessComponent {
  private authStore = inject(AuthenticationStore);

  onLogout(): void {
    this.authStore.logout();
  }
}
